// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__2WcEr","thumb":"Slider_thumb__shJbE","mark":"Slider_mark__ciIEf","label":"Slider_label__3Y6ab","valueLabel":"Slider_valueLabel__3PV6X"};